import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-page-orientation',
  templateUrl: './tooltip-info-page-orientation.component.html',
  styleUrls: ['./tooltip-info-page-orientation.component.scss'],
  standalone: false
})
export class TooltipInfoPageOrientationComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
